import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { ResetPasswordComponent } from '@go-modules/components/auth/reset-password/reset-password.component';

// TODO - remove when resetPassword STAB-631
export const ngxResetPasswordModule = angular.module('ngxResetPasswordModule', [])
	.directive('ngxResetPassword', downgradeComponent({component: ResetPasswordComponent}))
	.name;
